import Axios, { AxiosRequestConfig, InternalAxiosRequestConfig } from 'axios';
import Cookies from 'js-cookie';

import { FEATURES_FLAG_KEYS } from '@/features/featuresFlag/apis/featureFlag.keys';
import { useFeaturesFlagState } from '@/features/featuresFlag/hooks';

import { getAccessToken } from './react-msal/getAccessToken';

export const axios = Axios.create({
  baseURL: process.env.REACT_APP_BFF_APP_URI,
});

export const axiosWithoutInterceptors = Axios.create({
  baseURL: process.env.REACT_APP_BFF_APP_URI,
});

async function authRequestInterceptor(config: AxiosRequestConfig): Promise<InternalAxiosRequestConfig> {
  const isBpeEnabled = useFeaturesFlagState.getState().featuresFlag.get(FEATURES_FLAG_KEYS.BPE);

  let accessToken = '';

  if (isBpeEnabled) {
    accessToken = Cookies.get('authToken');
  } else {
    accessToken = await getAccessToken();
  }

  const headers = { ...config.headers, authorization: `Bearer ${accessToken}`, Accept: 'application/json' };

  return { ...config, headers } as unknown as InternalAxiosRequestConfig;
}

axios.interceptors.request.use(authRequestInterceptor);

axios.interceptors.response.use(
  (response) => response,
  (error) => {
    const isBpeEnabled = useFeaturesFlagState.getState().featuresFlag.get(FEATURES_FLAG_KEYS.BPE);
    const isSherpassEnabled = useFeaturesFlagState.getState().featuresFlag.get(FEATURES_FLAG_KEYS.SHERPASS);

    const message = error.response?.data?.message || error.message;
    // eslint-disable-next-line no-console
    console.error(message);

    if (isSherpassEnabled && error.response?.status === 401) {
      window.location.href = '/401';
    } else if (isBpeEnabled && error.response?.status === 401) {
      const win: Window = window;
      win.location = process.env.REACT_APP_PORTAL_URL;
    }
    //  else if (error.response?.status === 502) {
    //   window.location.href = '/502';
    // }
    else if (error.response?.status === 503) {
      window.location.href = '/503';
    } else if (error.response?.status === 504) {
      window.location.href = '/504';
    }

    return Promise.reject(error);
  },
);
